<template>
  <div id="image-gallary">
    <v-container fluid grid-list-xl class="px-6">
      <div v-if="!isDialog" class="selecte-all-block pr-1">
        <v-checkbox
          class="pa-0 ma-0"
          color="indigo darken-3"
          :label="selecteAllLabel"
          @change="selectAll"
          v-model="isSelectedAll"
          :disabled="uploadedFiles.length == 0"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <button
          class="btn-icon delete icon-Trash-cans_ic mr-2"
          @click="$refs.deleteDialogComponent.open()"
          :disabled="listSelected.length == 0"
        ></button>
        <slot name="upload-btn" />
      </div>
      <v-layout wrap class="list-of-photos">
        <v-flex
          v-for="(item, i) in uploadedFiles"
          :key="item.id"
          style="max-width: 20% ;width: 20%"
        >
          <div
            class="img-elm"
            draggable="true"
            @dragstart="dragStart(i, $event)"
            @dragover.prevent
            @dragenter="dragEnter"
            @dragleave="dragLeave"
            @dragend="dragEnd"
            @drop="dragFinish(i, $event)"
          >
            <div
              class="mask"
              :class="{ active: listSelected.map(x => x.id).includes(item.id) }"
              @click="deselectImage(item)"
            ></div>
            <v-img
              @click="selectImage(item)"
              :src="item.small"
              height="99px"
              style="border-radius: 10px"
            />
            <img v-if="!isDialog" src="@/assets/svg/arrow-expand.svg" @click.stop="showImage(item)" />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Modal -->
    <v-layout v-if="!isDialog">
      <v-dialog :keep-content-alive="false" v-model="dialog" max-width="832px">
        <div class="image-gallary-modal">
          <v-img contain :src="dataDialog.detail" alt height="464" max-width="100%" />
          <div class="row">
            <div class="col-lg-4">
              <p>{{ $t("FILE_NAME") }}: {{ dataDialog.fileName }}</p>
              <p>{{ $t("FILE_TYPE") }}: {{ dataDialog.fileType }}</p>
              <p>{{ $t("UPLOAD_BY") }}: {{ dataDialog.uploadBy }}</p>
            </div>
            <div class="col-lg-4">
              <p>{{ $t("FILE_CAPACITY") }}: {{ dataDialog.capacity }}</p>
              <p>{{ $t("SIZE") }}: {{ dataDialog.size }}</p>
              <p>{{ $t("UPLOAD_TIME") }}: {{ dataDialog.uploaded }}</p>
            </div>
            <div class="col-lg-4 d-flex justify-end align-end">
              <button class="btn btn-close" @click="dialog = false">{{ $t("CLOSE") }}</button>
            </div>
          </div>
        </div>
      </v-dialog>
    </v-layout>
    <delete-dialog
      v-if="!isDialog"
      :dialogDelete="dialogDelete"
      @deleteItem="deleteItem"
      ref="deleteDialogComponent"
    >
      <v-card-title slot="title" class="headline p-0">{{ $t("CONFIRM_DELETE_PHOTOS") }}?</v-card-title>
    </delete-dialog>
  </div>
</template>

<script>
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import { _alert } from "@/_helpers/function.js";
import { service } from "@/_services/UploadFile/upload-file.service.js";
export default {
  components: {
    "delete-dialog": DeleteDialog
  },
  props: {
    isDialog: Boolean,
    isChooseOneOnly: Boolean,
    totalFiles: Number,
    uploadedFiles: Array,
    selectedFiles: Array,
    paging: Object,
    setMainImage: Function
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      uploadDialog: false,
      dataDialog: {
        fileName: "",
        detail: "",
        fileType: "",
        size: "",
        uploaded: "",
        capacity: "",
        uploadBy: ""
      },
      listSelected: [],
      isSelectedAll: false
    };
  },
  created() {
    if (this.selectedFiles) {
      this.listSelected = this.selectedFiles.filter(x => x);
    }
  },
  watch: {
    dialog(value) {
      if (!value) {
        document.querySelector(".v-dialog--active").scrollTop = 0;
      }
    },
    justUploaded(value) {
      if (this.isDialog) {
        if (this.isChooseOneOnly) {
          if (value.length) this.listSelected.push(value[0]);
        } else {
          value.forEach(x => {
            let id = x.id;
            if (!this.listSelected.find(x => x.id == id))
              this.listSelected.push(x);
          });
        }
      }
    },
    listSelected(value) {
      if (value.length == this.uploadedFiles.length) {
        this.isSelectedAll = true;
      } else {
        this.isSelectedAll = false;
      }
      this.$emit("update:selectedFiles", value);
    }
  },
  computed: {
    justUploaded() {
      return this.$store.state.hotelImage.justUploaded;
    },
    selecteAllLabel() {
      return `${this.$t("SELECT_ALL")} (${this.totalFiles} ${this.$t(
        "IMAGES"
      )})`;
    }
  },
  methods: {
    upload() {
      this.$refs.uploadComponent.open();
    },
    deselectImage(item) {
      this.listSelected.splice(this.listSelected.indexOf(item), 1);
    },
    selectImage(item) {
      if (this.isChooseOneOnly) this.listSelected = [];
      this.listSelected.push(item);
    },
    selectAll(e, data) {
      if (e) this.isSelectedAll = true;
      if (e == false) this.isSelectedAll = false;
      this.removeAllSelected();
      if (!this.isDialog) {
        if (this.isSelectedAll)
          this.uploadedFiles.forEach(x => {
            this.listSelected.push(x);
          });
        return false;
      }
      if (this.isSelectedAll)
        data.forEach(x => {
          this.listSelected.push(x);
        });
    },
    showImage(item) {
      this.dialog = true;
      this.dataDialog = item;
    },
    async deleteItem() {
      let listNotDeleteSourceImg = ["hotel-image", "room-image"];
      if (listNotDeleteSourceImg.includes(this.$parent.$el.id)) {
        this.$emit("deleteImage", this.listSelected.map(x => x.id));
        return true;
      }
      let cloneData = this.uploadedFiles;
      this.listSelected.forEach(async x => {
        let user = JSON.parse(localStorage.getItem("currentUser"));
        let logo = user.hotel.logo;
        let img = x.img;
        await service.remove(x.id).then(res => {
          _alert(res, this.$t(res.data), false);
          if (res.responseCode == 0) {
            if (logo == img) {
              user.hotel.logo = null;
              localStorage.setItem("currentUser", JSON.stringify(user));
              document.querySelector(".logo").src =
                "/img/one-inventory-blue.2dc855fc.png";
              document.querySelector(".logo").width = 220;
            }
            cloneData.splice(cloneData.indexOf(x), 1);
            this.$emit("update:totalFiles", this.totalFiles - 1);
          }
        });
      });
      // await Promise.all(deleteItem);
      this.$emit("update:uploadedFiles", cloneData);
      this.listSelected = [];
      this.isSelectedAll = false;
      this.dialogDelete = false;
    },
    getListSelected() {
      return this.listSelected;
    },
    removeAllSelected() {
      this.listSelected = [];
    },
    dragStart(which, ev) {
      ev.dataTransfer.setData("Text", this.id);
      ev.dataTransfer.dropEffect = "move";
      this.dragging = which;
    },
    dragFinish(to) {
      this.moveItem(this.dragging, to);
    },
    moveItem(from, to) {
      if (to === -1) {
        this.removeItemAt(from);
      } else {
        let fromImage;
        let toImage;
        if (from < to) {
          // Cắt ảnh "to"
          toImage = this.uploadedFiles.splice(to, 1)[0];
          // Cắt ảnh "from"
          fromImage = this.uploadedFiles.splice(from, 1)[0];
          this.uploadedFiles.splice(from, 0, toImage);
          this.uploadedFiles.splice(to, 0, fromImage);
        } else {
          fromImage = this.uploadedFiles.splice(from, 1)[0];
          toImage = this.uploadedFiles.splice(to, 1)[0];
          this.uploadedFiles.splice(to, 0, fromImage);
          this.uploadedFiles.splice(from, 0, toImage);
        }
        // Đổi chỗ
        // if (from == 0 || to == 0) {
          this.$emit("setMainImage", this.uploadedFiles);
        // }
      }
    },
    removeItemAt(index) {
      this.uploadedFiles.splice(index, 1);
    },
    dragEnter() {},
    dragLeave() {},
    dragEnd() {
      this.dragging = -1;
    }
  }
};
</script>
